import { render, staticRenderFns } from "./IconBugOutline.vue?vue&type=template&id=07c08412&scoped=true"
var script = {}
import style0 from "./IconBugOutline.vue?vue&type=style&index=0&id=07c08412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c08412",
  null
  
)

export default component.exports